import { render, staticRenderFns } from "./AppAlertConfirm.vue?vue&type=template&id=211024c4&"
import script from "./AppAlertConfirm.vue?vue&type=script&lang=ts&"
export * from "./AppAlertConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports